import { FC, ReactNode, useEffect, useRef } from 'react'
import { Pagination, SelectPicker } from 'rsuite'
import './TableFooter.scss'

type TableFooterProps = {
  children?: ReactNode
  total: number
  pageSize: number
  currentPage: number
  pageSizeOptions?: number[]
  onPageChange: (page: number) => void
  onPageSizeChange: (value: number | null, event: React.SyntheticEvent) => void
  maxButtons?: number
}
const TableFooter: FC<TableFooterProps> = ({
  children,
  total,
  pageSize,
  currentPage,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
  maxButtons,
  ...props
}) => {
  const paginationRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!paginationRef.current) return undefined
    const el = paginationRef.current
    const applyActiveStyles = () => {
      el.querySelectorAll<HTMLElement>('.rs-pagination-btn-active').forEach(
        (node) => {
          Object.assign(node.style, {
            backgroundColor: 'var(--text-color-heading, #4c0e58)',
            borderColor: 'var(--text-color-heading, #4c0e58)',
            color: '#fff',
            boxShadow: 'none'
          })
        }
      )
    }
    applyActiveStyles()
    const observer = new MutationObserver(applyActiveStyles)
    observer.observe(el, { childList: true, subtree: true, attributes: true })
    return () => observer.disconnect()
  }, [currentPage, total])

  return (
    <div {...props} className="table-footer">
      <div className="table-footer__left">{children}</div>
      <div className="table-footer__right">
        {pageSizeOptions && (
          <>
            <span className="table-footer__rows-per-page-label">
              Rows per page:
            </span>
            <SelectPicker
              data={pageSizeOptions.map((size) => ({
                label: size.toString(),
                value: size
              }))}
              value={pageSize}
              onChange={onPageSizeChange}
              cleanable={false}
              searchable={false}
              className="table-footer__select"
              placement="topEnd"
            />
          </>
        )}
        <div>
          <Pagination
            activePage={currentPage}
            limit={pageSize}
            total={total}
            onChangePage={onPageChange}
            size="sm"
            layout={['pager']}
            prev
            next
            maxButtons={maxButtons}
            first
            last
            ellipsis
            className="table-footer__pagination"
          />
        </div>
      </div>
    </div>
  )
}
TableFooter.defaultProps = {
  children: null
}
export default TableFooter
